import SEO from "@/components/SEO";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ProblemSection from "@/components/landing/ProblemSection";
import WhyMatters from "@/components/landing/WhyMatters";
import HowItWorks from "@/components/landing/HowItWorks";
import WorkspaceSection from "@/components/landing/WorkspaceSection";
import ConnectedWorkspace from "@/components/landing/ConnectedWorkspace";
import Outcomes from "@/components/landing/Outcomes";
import FAQ, { faqData } from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function CarrierCoordination() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "FreightIQ™ by DeMaxtore",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    description:
      "FreightIQ™ is the carrier coordination Workspace Product inside DeMaxtore. Manage carriers, container bookings, shipment schedules and freight operations from one Workspace.",
    offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "DeMaxtore", item: "/" },
      { "@type": "ListItem", position: 2, name: "Carrier Coordination", item: "/carrier-coordination" },
    ],
  };

  return (
    <>
      <SEO
        title="Carrier Coordination Software | FreightIQ™ by DeMaxtore"
        description="Coordinate carriers, container bookings, shipment schedules and freight operations from one Workspace with FreightIQ™ by DeMaxtore."
        canonical="/carrier-coordination"
        jsonLd={[faqSchema, productSchema, breadcrumbSchema]}
      />

      <main className="min-h-screen overflow-x-hidden bg-white text-navy">
        <Navbar />
        <Hero />
        <ProblemSection />
        <WhyMatters />
        <HowItWorks />
        <WorkspaceSection />
        <ConnectedWorkspace />
        <Outcomes />
        <FAQ />
        <FinalCTA />
        <Footer />
      </main>
    </>
  );
}
